import * as THREE from 'three';

const MASK_LIGHT = new THREE.Color(0xffffff);
const MASK_DARK = new THREE.Color(0xb8b8b8);
export const MASK_CELL_METRES = 0.25;

export function applyMaskChecker(
  material: THREE.Material,
  cellMetres = MASK_CELL_METRES,
  lightColour: THREE.Color = MASK_LIGHT,
  darkColour: THREE.Color = MASK_DARK,
): void {
  material.onBeforeCompile = (shader) => {
    shader.uniforms.uMaskCell = { value: cellMetres };
    shader.uniforms.uMaskLight = { value: lightColour };
    shader.uniforms.uMaskDark = { value: darkColour };

    shader.vertexShader = shader.vertexShader
      .replace('#include <common>', '#include <common>\nvarying vec3 vMaskObjectPos;')
      .replace(
        '#include <begin_vertex>',
        '#include <begin_vertex>\nvMaskObjectPos = transformed;',
      );

    shader.fragmentShader = shader.fragmentShader
      .replace(
        '#include <common>',
        '#include <common>\nvarying vec3 vMaskObjectPos;\nuniform float uMaskCell;\nuniform vec3 uMaskLight;\nuniform vec3 uMaskDark;',
      )
      .replace(
        '#include <color_fragment>',
        '#include <color_fragment>\n{\n  vec3 cell = floor(vMaskObjectPos / uMaskCell);\n  float checker = mod(cell.x + cell.y + cell.z, 2.0);\n  diffuseColor.rgb *= mix(uMaskLight, uMaskDark, checker);\n}',
      );
  };
  material.customProgramCacheKey = () =>
    `lureo-mask-checker-${cellMetres}-${lightColour.getHexString()}-${darkColour.getHexString()}`;
  material.needsUpdate = true;
}

export function createMaskCheckerMaterial(
  cellMetres = MASK_CELL_METRES,
  lightColour: THREE.Color = MASK_LIGHT,
  darkColour: THREE.Color = MASK_DARK,
): THREE.MeshStandardMaterial {
  const material = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.9, metalness: 0 });
  applyMaskChecker(material, cellMetres, lightColour, darkColour);
  return material;
}

export const MASK_CELLS_ACROSS = 8;

export function maskCellForGeometry(geometry: THREE.BufferGeometry): number {
  if (!geometry.boundingBox) geometry.computeBoundingBox();
  const size = geometry.boundingBox?.getSize(new THREE.Vector3());
  const extent = size ? Math.max(size.x, size.y, size.z) : 0;
  if (!Number.isFinite(extent) || extent <= 0) return MASK_CELL_METRES;
  return extent / MASK_CELLS_ACROSS;
}
